<script setup>
const route = useRoute()

const breadCrumbList = [{ text: '服装予報', link: '/clothes/' }, { text: '服装に関するニュース一覧' }]

useCustomMetaTopics({ path: route.path })
useCustomJsonldPoint({ breadCrumbList })
</script>

<template>
  <div>
    <NuxtLayout
      :bread-crumb-list="breadCrumbList"
      ads-key="area"
      name="common"
    >
      <ClothesTopics />
    </NuxtLayout>
  </div>
</template>

<style scoped>
</style>
